import React, { useMemo } from 'react';
import { DollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ModuleAlertsPage from '../../shared/components/ModuleAlertsPage';
import { getWpsDeadline, formatPayrollDate, WPS_PAYMENT_DAY } from './utils/payrollSaudiFormat';

const SalariesAlertsPage = () => {
  const { t, i18n } = useTranslation();
  const p = (key, opts) => t(`modules.salaires.pages.salariesAlertsPage.${key}`, opts);

  const now = new Date();
  const wpsDeadline = getWpsDeadline(now.getFullYear(), now.getMonth() + 1);
  const daysUntilWps = Math.ceil((wpsDeadline - now) / (1000 * 60 * 60 * 24));
  const wpsDateLabel = formatPayrollDate(wpsDeadline, { language: i18n.language });

  const alerts = useMemo(
    () => [
      {
        id: 1,
        type: daysUntilWps <= 5 ? 'warning' : 'info',
        priority: daysUntilWps <= 3 ? 'critical' : 'high',
        title: p('alert_wps_title'),
        message: p('alert_wps_message', { date: wpsDateLabel, day: WPS_PAYMENT_DAY, days: Math.max(daysUntilWps, 0) }),
        date: now.toISOString().split('T')[0],
        read: false,
      },
      {
        id: 2,
        type: 'warning',
        priority: 'high',
        title: p('alert_gosi_registration_title'),
        message: p('alert_gosi_registration_message'),
        date: now.toISOString().split('T')[0],
        read: false,
      },
      {
        id: 3,
        type: 'error',
        priority: 'critical',
        title: p('alert_bank_details_title'),
        message: p('alert_bank_details_message'),
        date: new Date(Date.now() - 86400000).toISOString().split('T')[0],
        read: false,
      },
      {
        id: 4,
        type: 'warning',
        priority: 'medium',
        title: p('alert_minimum_wage_title'),
        message: p('alert_minimum_wage_message'),
        date: now.toISOString().split('T')[0],
        read: false,
      },
      {
        id: 5,
        type: 'info',
        priority: 'medium',
        title: p('alert_overtime_title'),
        message: p('alert_overtime_message'),
        date: now.toISOString().split('T')[0],
        read: true,
      },
      {
        id: 6,
        type: 'info',
        priority: 'low',
        title: p('alert_unpaid_leave_title'),
        message: p('alert_unpaid_leave_message'),
        date: now.toISOString().split('T')[0],
        read: true,
      },
      {
        id: 7,
        type: 'info',
        priority: 'medium',
        title: p('alert_eosb_title'),
        message: p('alert_eosb_message'),
        date: now.toISOString().split('T')[0],
        read: false,
      },
      {
        id: 8,
        type: 'warning',
        priority: 'high',
        title: p('alert_payroll_calc_title'),
        message: p('alert_payroll_calc_message'),
        date: now.toISOString().split('T')[0],
        read: false,
      },
    ],
    [p, wpsDateLabel, daysUntilWps, now]
  );

  return <ModuleAlertsPage moduleName={p('module_name')} moduleIcon={DollarSign} alerts={alerts} />;
};

export default SalariesAlertsPage;
